/**
 * cart-bfcache-refresh.js
 *
 * Fixes: checkout se "back" button/browser back-forward navigation se cart page
 * par aane par kabhi kabhi cart bubble aur cart items stale (empty ya purani
 * count) dikhte hain — kyunki browser page ko bfcache (back-forward cache)
 * se restore karta hai, server se fresh render nahi hota.
 *
 * Fix: jab bhi page bfcache se restore ho (pageshow event with persisted=true,
 * ya navigation type "back_forward"), hum live /cart.js call karke asli cart
 * state check karte hain. Agar dikhayi de rahi cart bubble count ya cart items
 * count, asli cart se match nahi karti, to page ko reload kar dete hain taaki
 * server se fresh, sahi cart state render ho.
 *
 * Isse full theme internals (custom elements/refs) chhedne ki zaroorat nahi
 * padti — bas mismatch hone par hi reload hota hai, warna kuch nahi hota.
 */
(function () {
  function isBackForwardNavigation(event) {
    if (event.persisted) return true;

    var entries = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];

    return entries.length > 0 && entries[0].type === 'back_forward';
  }

  function checkAndRefreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // Cart bubble (cart-icon-bubble.liquid) count check
        var bubbleCountEl = document.querySelector('[ref="cartBubbleCount"]');
        var bubbleShownCount = bubbleCountEl
          ? parseInt(bubbleCountEl.textContent, 10) || 0
          : null;

        // Cart page (cart-products.liquid) rendered line items check
        var hasCartItemsWrapper = document.querySelector('.cart-items__wrapper');
        var renderedItemRows = document.querySelectorAll('[ref="cartItemRows[]"]').length;

        var bubbleMismatch =
          bubbleCountEl !== null && bubbleShownCount !== cart.item_count;

        var cartPageMismatch =
          hasCartItemsWrapper !== null && renderedItemRows !== cart.items.length;

        if (bubbleMismatch || cartPageMismatch) {
          window.location.reload();
        }
      })
      .catch(function () {
        // Silently ignore - agar /cart.js fail ho jaaye to kuch mat karo,
        // user ko manual refresh karna padega jaise pehle hota tha.
      });
  }

  window.addEventListener('pageshow', function (event) {
    if (isBackForwardNavigation(event)) {
      checkAndRefreshCart();
    }
  });
})();
